import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Mouse silhouette uses the ★1 tier art. The active rendering
// for Pocket Mouse goes through TIERED_GLYPHS (see tieredGlyphs.ts)
// which routes ★2/★3 to the richer tier images extracted from
// assets/pocket_mouse_3tier.jpg.
export const Mouse = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/mouse-1.png" size={size} alt="mouse" />
)
